import { Navigate, Route, Routes } from "react-router-dom";
import Login from "@/pages/socio/Login";
import Setup from "@/pages/socio/Setup";
import Dashboard from "@/pages/socio/Dashboard";
import Settings from "@/pages/socio/Settings";
import Import from "@/pages/socio/Import";
import Claim from "@/pages/socio/Claim";
import Send from "@/pages/socio/Send";
import Proposals from "@/pages/socio/Proposals";
import Activity from "@/pages/socio/Activity";
import OrganizationPage from "@/pages/socio/Organization";
import Deploy from "@/pages/admin/Deploy";
import Projects from "@/pages/admin/Projects";
import NewProject from "@/pages/admin/NewProject";
import AdminActivity from "@/pages/admin/Activity";

function Placeholder({ name }: { name: string }) {
  return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold">{name}</h1>
      <p className="text-app-muted mt-2">Tela ainda não implementada.</p>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/setup" element={<Setup />} />
      <Route path="/ativar" element={<Setup />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/claim" element={<Claim />} />
      <Route path="/send" element={<Send />} />
      <Route path="/proposals" element={<Proposals />} />
      <Route path="/atividade" element={<Activity />} />
      <Route path="/organizacao" element={<OrganizationPage />} />
      <Route path="/admin" element={<Navigate to="/admin/projects" />} />
      <Route path="/admin/activity" element={<AdminActivity />} />
      <Route path="/admin/deploy" element={<Deploy />} />
      <Route path="/admin/projects" element={<Projects />} />
      <Route path="/admin/projects/new" element={<NewProject />} />
      <Route path="/import" element={<Import />} />
      <Route path="*" element={<Placeholder name="404" />} />
    </Routes>
  );
}
